"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Preview = (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.maybeRenderEditButton = function () {
            var _a = _this.props, isEditable = _a.isEditable, editUrl = _a.editUrl;
            if (isEditable) {
                return (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, href: function () { return editUrl || ""; }, size: kaleidoscope_2.ButtonSize.Small }, "Edit"));
            }
        };
        return _this;
    }
    Preview.prototype.render = function () {
        var _a = this.props, projectName = _a.projectName, shareProject = _a.shareProject, done = _a.done, previewUrl = _a.previewUrl;
        return (react_1.default.createElement("div", { className: "hubspot" },
            react_1.default.createElement("div", { className: "header preview" },
                react_1.default.createElement("div", { className: "title" }, projectName),
                react_1.default.createElement("div", { className: "actions" },
                    this.maybeRenderEditButton(),
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: shareProject, size: kaleidoscope_2.ButtonSize.Small }, "Share"),
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, onClick: done, size: kaleidoscope_2.ButtonSize.Small },
                        react_1.default.createElement(icons_1.Tick, null),
                        " Done"))),
            react_1.default.createElement("iframe", { src: previewUrl })));
    };
    Preview = __decorate([
        mobx_react_1.observer
    ], Preview);
    return Preview;
}(react_1.default.Component));
exports.Preview = Preview;
